import { createActionGroup, emptyProps, props } from '@ngrx/store';

export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

export const UiActions = createActionGroup({
  source: 'UI',
  events: {
    'Toggle Sidebar': emptyProps(),
    'Set Global Loading': props<{ loading: boolean }>(),
    'Show Toast': props<{ severity: ToastSeverity; summary: string; detail: string }>(),
    'Clear Toast': emptyProps(),
  },
});
